import { Paper, styled } from "@mui/material"

const Dropzone = styled(Paper)(({ isDragActive }: { isDragActive: boolean }) => ({
	minWidth: 'auto !important',
	maxWidth: 'auto !important',
	height: 'auto !important',

	gridColumn: 'span 4',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: '0.5rem',

	paddingInline: '1.5rem',
	paddingBlock: '1rem',

	borderStyle: 'solid',
	borderWidth: '1px',
	borderColor: isDragActive ? '#3b82f6' : '#d1d5db',
	borderRadius: '0.5rem !important',

	backgroundColor: isDragActive ? '#eff6ff' : '#fafafa',
	cursor: 'pointer',
	transition: 'all 0.2s ease-in-out',
	boxShadow: 'none',

	'&:hover': {
		borderColor: '#3b82f6',
		backgroundColor: '#eff6ff',
	},

	'&:has(:disabled)': {
		opacity: '50%',
		pointerEvents: 'none'
	}
}))

export { Dropzone }